var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('button',{staticClass:"mr-3 btn",class:[_vm.data.closed ? 'btn-default' : 'btn-warning'],attrs:{"disabled":_vm.data.closed ? true : false},on:{"click":_vm.closeShift}},[_vm._v("\n     "+_vm._s(!_vm.data.closed ? 'Close Shift' : 'Shift closed')+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }